import { MAILING_SERVICE_URL, MAILING_API_KEY, MAILING_SERVICE_TIMEOUT } from "@config/config";
import { EmailService } from "./EmailService";

export const emailService = new EmailService({
  serviceURL: MAILING_SERVICE_URL,
  serviceApiKey: MAILING_API_KEY,
  mailingTimeout: MAILING_SERVICE_TIMEOUT
});
